import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { NgbDatepickerConfig, NgbDateStruct } from '@ng-bootstrap/ng-bootstrap';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import * as moment from 'moment';

import { UserService } from '../services/user.service'
import { CheckEmail } from '../services/validators/check-email.validator'
import { EmailTaken } from '../services/validators/email-taken.validator'
import { CheckPassword } from '../services/validators/check-password.validator'
import { MatchFields } from '../services/validators/match-fields.validator'

import { fadeInUp } from '../services/animations/fadeInUp.animation'

import { ImageCroppedEvent } from 'ngx-image-cropper';

@Component({
    selector: 'app-signup',
    templateUrl: './signup.component.html',
    animations: [fadeInUp]
})
export class SignUpPageComponent implements OnInit {

    registerUser: FormGroup;
    datePickerModel: NgbDateStruct;

    // Template Variable
    errors: any = []
    signupStep: string = 'landing';
    selectAvatarOverlay: boolean = false;
    selectedAvatar: Number;
    selectedUserType: string;
    dateSelected: Boolean = false;

    abnValidatorTimeout: any;
    abnValid: Boolean = false;
    abnFieldLabel: String = 'Business ABN';
    abnLength: Number = 11;
    checkingAbn: boolean = false;

    mongooseUniqueValueError = 11000;

	imageChangedEvent: any = '';
	croppedImage: any = '';
    fileName: any = '';

    constructor (
        private fbuilder: FormBuilder,
        private datePickerConfig: NgbDatepickerConfig,
        private router: Router,
        private userService: UserService,
        private emailTaken: EmailTaken,
        private browserAnimationsModule: BrowserAnimationsModule
    ) {
        datePickerConfig.minDate = { year: 1900, month: 1, day: 1 };
        datePickerConfig.maxDate = { year: moment().year(), month: moment().month() + 1, day: moment().date() };
        datePickerConfig.outsideDays = 'collapsed';


        setTimeout(() => {
            document.getElementsByClassName('c-signup--bg')[0].classList.add('is-visible')
        }, 10);
        setTimeout(() => {
            this.signupStep = 'landing';
        }, 300);

        this.registerUser = fbuilder.group({
            'firstName': [null, Validators.compose([Validators.required, Validators.minLength(2)])],
            'lastName': [null, Validators.compose([Validators.required, Validators.minLength(2)])],
            'email': [null, Validators.compose([Validators.required, CheckEmail]), this.emailTaken.validate.bind(this) ],
            'emailConfirm': [null, Validators.compose([Validators.required, MatchFields('email')])],
            'password': [null, Validators.compose([Validators.required, CheckPassword])],
            'passwordConfirm': [null, Validators.compose([Validators.required, MatchFields('password')])],
            'userType': [null, Validators.compose([Validators.required])],
            'avatar': [0, Validators.compose([Validators.required])],
            'profileImage': [null],
            'gender': [null, Validators.compose([Validators.required])],
            'dateOfBirth': [null],
            'businessName': [null],
            'nickName': [null],
            'abn': [null],
            'jobTitle': [null],
            'optIn': [true]
        });
        this.formChanges()
    }

    ngOnInit() {
    }

    validateABN(value) {
        if (value && value !== '') {
            if (value.toString().length === this.abnLength) {
                this.checkingAbn = true;
                clearTimeout(this.abnValidatorTimeout);
                this.abnValidatorTimeout = setTimeout(() => {
                    const data = { abn: value };
                    this.userService.checkABN(data).subscribe((res: any) => {
                        if (res) {
                            this.abnFieldLabel = res.EntityName;
                        } else {
                            this.abnFieldLabel = 'Business ABN';
                            this.registerUser.controls['abn'].setErrors({ 'invalidAbn': true });
                        }
                        this.checkingAbn = false;
                    })
                }, 600)
            } else {
                this.abnFieldLabel = 'Business ABN';
                this.registerUser.controls['abn'].setErrors({ 'invalidAbn': true });
            }
        }
    }

    formChanges() {
        this.registerUser.valueChanges.subscribe(val => {
            this.errors = [];
        });
        this.registerUser.controls['abn'].valueChanges.subscribe(val => {
            if (this.selectedUserType === 'Employer') {
                this.validateABN(val)
            }
        });
    }

    emailInputChange(event) {
        this.registerUser.controls[ event.target.attributes.formcontrolname.nodeValue ].setValue(event.target.value.trim().toLowerCase())
    }

    selectUserType(value) {
        document.getElementsByClassName('c-signup--bg')[0].classList.remove('is-visible')
        if (value) {
            this.signupStep = 'form';
            this.selectedUserType = value;
            this.registerUser.controls['userType'].setValue(null)

            this.registerUser.controls['abn'].setValue(null)
            this.registerUser.controls['abn'].setValidators([])
            this.registerUser.controls['businessName'].setValue(null)
            this.registerUser.controls['businessName'].setValidators([])
            this.registerUser.controls['jobTitle'].setValue(null)
            this.registerUser.controls['jobTitle'].setValidators([])
            this.registerUser.controls['dateOfBirth'].setValue(null)
            this.registerUser.controls['dateOfBirth'].setValidators([])
			this.registerUser.controls['nickName'].setValue(null)
			this.registerUser.controls['nickName'].setValidators([]);
            if (value === 'Employer') {
                this.registerUser.controls['businessName'].setValidators([Validators.required]);
                this.registerUser.controls['abn'].setValidators([Validators.required]);
                this.registerUser.controls['jobTitle'].setValidators([Validators.required]);
                this.registerUser.controls['userType'].setValue(value)
            }
            if (value === 'Student') {
				this.registerUser.controls['nickName'].setValidators([Validators.required, Validators.minLength(2)]);
                this.registerUser.controls['dateOfBirth'].setValidators([Validators.required]);
                this.registerUser.controls['userType'].setValue(value)
            }
            this.registerUser.controls['dateOfBirth'].updateValueAndValidity()
            this.registerUser.controls['businessName'].updateValueAndValidity()
            this.registerUser.controls['jobTitle'].updateValueAndValidity()
            this.registerUser.controls['abn'].updateValueAndValidity()
            this.registerUser.controls['userType'].updateValueAndValidity()
        }
        setTimeout(() => {
            document.getElementsByClassName('c-signup--bg')[0].classList.add('is-visible')
        }, 10);
    }

    selectAvatar(value) {
        if (value) {
            this.selectedAvatar = value;
            this.registerUser.controls['avatar'].setValue(value)
        }
    }

    openOverlay(target) {
        document.getElementsByTagName('html')[0].classList.add('scroll-lock')
        document.getElementById(target).classList.add('is-block');
        setTimeout(function () {
            document.getElementById(target).classList.add('is-visible');
        }, 10);
		if (target == 'overlay-selectavatar' && !this.croppedImage) {
			document.getElementById("selectFileInput").click();
		}
    }

    closeOverlay(target) {
        document.getElementsByTagName('html')[0].classList.remove('scroll-lock')
        document.getElementById(target).classList.remove('is-visible');
        setTimeout(function () {
            document.getElementById(target).classList.remove('is-block');
        }, 500);
    }

    dateOverlay(event) {
        if (event.target.id === 'overlay-datepicker' && this.registerUser.controls['dateOfBirth'].status === 'VALID') {
            this.closeOverlay('overlay-datepicker')
        }
    }

    onDateSelect(event) {
        event.month = event.month - 1;
        this.dateSelected = true;
        var selectedDate = moment(event).format('DD MMMM YYYY');
        this.registerUser.controls['dateOfBirth'].setValue(selectedDate)
        this.closeOverlay('overlay-datepicker')
    }

	fileChangeEvent(event: any): void {
		this.imageChangedEvent = event;
        if (event.target.value) {
            this.fileName = event.target.value.split(/(\\|\/)/g).pop()
        }
	}
	imageCropped(event: ImageCroppedEvent) {
		this.croppedImage = event.base64;
		this.registerUser.controls['profileImage'].setValue(this.croppedImage)
	}
	imageLoaded() {
		// show cropper
	}
	cropperReady() {
		// cropper ready
	}
	loadImageFailed() {
		// show message
	}

    cancelSignUp() {
        this.signupStep = 'landing';
        this.selectedUserType = '';
        this.selectedAvatar = null;
        this.registerUser.controls['avatar'].setValue(0)
        this.registerUser.controls['userType'].setValue(null)
    }

    submitUserForm(isValid: boolean, submission) {
        this.errors = [];
        if (isValid) {
            this.userService.registerUser(submission).then(result => {
                this.router.navigate(['./welcome']);
            }).catch(error => {
                let err = error.json()
                if (err && err.code && err.code === this.mongooseUniqueValueError) {
                    this.errors.push({ msg: 'This email address is already in use.'});
                } else {
                    this.errors = err;
                }
            })
        }
    }

}



// WEBPACK FOOTER //
// ./src/app/login/signup.component.ts